import styled from "styled-components";

const QrButton = styled.button.attrs(({ field, page }) => ({
  style: {
    top: field.yMod * page.height,
    left: field.xMod * page.width,
    height: field.heightMod * page.height,
    width: field.widthMod * page.width,
  },
}))`
  position: absolute;
  font-size: 1rem;
  outline: 1px solid-black;
  border: 1px solid-black;

  &:focus {
    outline: 3px solid #2bd1e3;
  }
`;

export default QrButton;